import { render, staticRenderFns } from "./FileInColdStorageDialog.vue?vue&type=template&id=7ead4733&scoped=true&"
import script from "./FileInColdStorageDialog.vue?vue&type=script&lang=js&"
export * from "./FileInColdStorageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead4733",
  null
  
)

export default component.exports